<div class="container-fluid"> 
    <div class="row">
        <div class="col">
            <div class="border-0 px-4 py-1 scroll-container" ref="manage_enquiries_form">
                <NavigationBackButton/>
                <!-- Row with cards with counts -->
                <!-- Enquiries Cards Row -->
                <div class="row mt-3">
                <!-- Total Enquiries -->
                <div class="col-12 col-sm-6 col-md-3 mb-3 d-flex">
                    <div class="w-100 h-100">
                    <div class="card text-white border-0 shadow rounded-5 overview-card-bg responsive-card h-100">
                        <div class="card-body d-flex align-items-center gap-3 py-3 px-3">
                        <div class="circular-icon d-flex align-items-center justify-content-center flex-shrink-0 responsive-icon">
                            <i class="fa-solid fa-circle-question fa-lg text-primary-blue"></i>
                        </div>
                        <div class="d-flex flex-column justify-content-center text-start flex-grow-1">
                            <p class="mb-1 text-xs text-white">Total Enquiries</p>
                            <p class="m-0 fw-bold text-white">{{ question_forms.length }}</p>
                        </div>
                        </div>
                    </div>
                    </div>
                </div>

                <!-- Active Enquiries -->
                <div class="col-12 col-sm-6 col-md-3 mb-3 d-flex">
                    <div class="w-100 h-100">
                    <div class="card text-white border-0 shadow rounded-5 overview-card-bg responsive-card h-100">
                        <div class="card-body d-flex align-items-center gap-3 py-3 px-3">
                        <div class="circular-icon d-flex align-items-center justify-content-center flex-shrink-0 responsive-icon">
                            <i class="fa-solid fa-person-circle-question fa-lg text-primary-blue"></i>
                        </div>
                        <div class="d-flex flex-column justify-content-center text-start flex-grow-1">
                            <p class="mb-1 text-xs text-white">Active Enquiries</p>
                            <p class="m-0 fw-bold text-white">{{active_enquiries_count}}</p>
                        </div>
                        </div>
                    </div>
                    </div>
                </div>

                <!-- Completed Enquiries -->
                <div class="col-12 col-sm-6 col-md-3 mb-3 d-flex">
                    <div class="w-100 h-100">
                    <div class="card text-white border-0 shadow rounded-5 overview-card-bg responsive-card h-100">
                        <div class="card-body d-flex align-items-center gap-3 py-3 px-3">
                        <div class="circular-icon d-flex align-items-center justify-content-center flex-shrink-0 responsive-icon">
                            <i class="fa-solid fa-person-circle-check fa-lg text-primary-blue"></i>
                        </div>
                        <div class="d-flex flex-column justify-content-center text-start flex-grow-1">
                            <p class="mb-1 text-xs text-white">Completed Enquiries</p>
                            <p class="m-0 fw-bold text-white">0</p>
                        </div>
                        </div>
                    </div>
                    </div>
                </div>

                <!-- Actionable Enquiries -->
                <div class="col-12 col-sm-6 col-md-3 mb-3 d-flex">
                    <div class="w-100 h-100">
                    <div class="card text-white border-0 shadow rounded-5 overview-card-bg responsive-card h-100">
                        <div class="card-body d-flex align-items-center gap-3 py-3 px-3">
                        <div class="circular-icon d-flex align-items-center justify-content-center flex-shrink-0 responsive-icon">
                            <i class="fa-solid fa-person-circle-exclamation fa-lg text-primary-blue"></i>
                        </div>
                        <div class="d-flex flex-column justify-content-center text-start flex-grow-1">
                            <p class="mb-1 text-xs text-white">Actionable Enquiries</p>
                            <p class="m-0 fw-bold text-white">0</p>
                        </div>
                        </div>
                    </div>
                    </div>
                </div>
                </div>

                <div class="glassy-table rounded-lg border-0 mt-2 shadow">
                    <div class="card-header rounded-lg border-0 mb-0">
                        <div class="d-flex justify-content-between align-items-center">
                            
                            <!-- Title on the left -->
                            <h6 class="mb-0 fw-bold text-dark">
                            Enquiry Forms
                            </h6>

                            <!-- Button on the right -->
                            <button 
                            class="btn btn-primary-dark btn-sm rounded-small text-xxs shadow text-dark p-2 mt-2"
                            data-bs-toggle="modal"
                            data-bs-target="#create_enquiry_form"
                            >
                            Create Enquiry Form
                            </button>

                        </div>
                        </div>

                    <div class="card-body pt-0">
                        <GlobalTable
                        :headers="['ID', 'Form Name', 'Form Description', 'Status', 'Date Created', 'Data Updated']"
                        :data="question_forms"
                        :table_id="enquiry_questions_table">
                        <template #actions="{ row }">
                            <button class="btn btn-primary-dark text-dark btn-sm rounded-3 small shadow me-2 text-xxs"@click="assign_questions_to_form(row.ID,row['Form Name'])">Manage</button>
                            <button v-if="row.Status === 'Active'" class="btn btn-primary-dark text-dark btn-sm rounded-3 small shadow me-2 text-xxs" @click="deactivate_enquiry_form(row.ID)">Deactivate</button>
                            <button v-else class="btn btn-primary-dark text-dark btn-sm rounded-3 small shadow me-2 text-xxs" @click="activate_enquiry_form(row.ID)">Activate</button>
                            <button class="btn btn-primary-dark text-dark btn-sm rounded-3 small shadow me-2 text-xxs" data-bs-toggle="modal" data-bs-target="#edit_enquiry_form" @click="open_edit_modal(row)">
                                Edit</button>
                        </template>
                        </GlobalTable>
                    </div>
                </div>
                <AICampusFooter/>
            </div>
        </div>
    </div>
</div>

<!-- Modal for Creating Enquiry Form -->
 <teleport to="body">
<div class="modal fade" id="create_enquiry_form" tabindex="-1" aria-labelledby="create_enquiry_form_label" aria-hidden="true">
    <div class="modal-dialog modal-dialog-centered">
        <div class="modal-content bg-white rounded-3 p-0 shadow-lg">
            <div class="modal-header border-bottom-0 cute-header shadow-lg">
                <p class="modal-title text-white text-xxs" id="create_enquiry_form_label">Create Enquiry Form</p>
                <button type="button" class="modal-btn-close btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
            </div>
            <div class="modal-body">
                <div class="modal-form-group form-group mb-3">
                    <label for="enquiry_form_name" class="modal-form-label form-label text-xxs">Enquiry Form Name:</label>
                    <input type="text" v-model="enquiry_form_name" class="modal-form-control form-control text-xxs rounded-small p-2 shadow-sm" placeholder="Enter Enquiry Form Name Here">
                    <small class="text-danger p-2 text-xxs fw-bold d-none form-name-messages">Please enter an enquiry form name</small>
                    <small class="text-danger p-2 text-xxs fw-bold d-none error-messages"></small>
                </div>
                <div class="modal-form-group form-group mb-3">
                    <label for="enquiry_form_description" class="modal-form-label form-label text-xxs">Enquiry Form Description:</label>
                    <textarea v-model="enquiry_form_description"
                              class="modal-form-control form-control text-xxs rounded-small p-2 shadow-sm"
                              placeholder="Enter Enquiry Form Description Here"
                              rows="4" cols="10">
                    </textarea>
                    <small class="text-danger p-2 text-xxs fw-bold d-none description-messages">Please enter a description</small>
                    <small class="text-danger p-2 text-xxs fw-bold d-none error-messages"></small>
                </div>
            </div>
            <div class="modal-footer border-0 p-2 d-flex justify-content-end">
                <button type="button"
                        class="btn btn-primary-dark btn-sm rounded-small text-xxs shadow text-dark"
                        @click="create_enquiry_form">
                    Save
                </button>
            </div>
        </div>
    </div>
</div>
</teleport>
<!-- edit modal -->
 <teleport to="body">
<div class="modal fade" id="edit_enquiry_form" tabindex="-1" aria-labelledby="edit_enquiry_form_label" aria-hidden="true">
    <div class="modal-dialog modal-dialog-centered">
      <div class="modal-content bg-white rounded-3 p-0 shadow-lg">
        <div class="modal-header border-bottom-0 cute-header shadow-lg">
          <p class="modal-title text-white text-xxs" id="edit_enquiry_form">Edit Enquiry Form</p>
          <button type="button" class="modal-btn-close btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
        </div>
        <div class="modal-body">
          <div class="modal-form-group form-group mb-3">
            <label for="trust_type_name" class="modal-form-label form-label text-xxs">Enquiry Form Name:</label>
            <input type="text" v-model="update_enquiry_form_name" class="modal-form-control form-control text-xxs rounded-small p-2 shadow-sm" placeholder="Enter the enquiry form name">
            <small class="text-danger p-2 text-xxs fw-bold d-none edit-entity-type-messages">Please enter an enquiry form name</small>
            <small class="text-danger p-2 text-xxs fw-bold d-none error-messages"></small>
          </div>
          <div class="modal-form-group form-group mb-3">
            <label for="trust_type_name" class="modal-form-label form-label text-xxs">Enquiry Form Type:</label>
            <textarea type="text" v-model="update_enquiry_form_description"
              class="modal-form-control form-control text-xxs rounded-small p-2 shadow-sm"
              rows="4" cols="10" placeholder="Enter enquiry form type">
            </textarea>
            <small class="text-danger p-2 text-xxs fw-bold d-none edit-entity-type-description-messages">Please enter a description</small>
            <small class="text-danger p-2 text-xxs fw-bold d-none error-messages"></small>
          </div>
        </div>
        <div class="modal-footer border-0 p-2 d-flex justify-content-end">
            <button type="button"
            class="btn btn-primary-dark btn-sm rounded-small text-xxs shadow text-dark"
            @click="edit_enquiry_form">
            Save
           </button>
        </div>
      </div>
    </div>
</div>
</teleport>

